import React from "react";
import Disclaimer from "@/components/disclaimer-trade/disclaimer";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Disclaimer & Trade",
};

const DisclaimerandTradeScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Disclaimer />
    </>
  );
};

export default DisclaimerandTradeScreen;
